var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66846 11.1765L2.66846 8.82358H9.32358L9.32358 2.16846H11.6765L11.6765 8.82358H18.3316V11.1765H11.6765V17.8316H9.32358V11.1765L2.66846 11.1765Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusLg);
export default __webpack_public_path__ + "static/media/icon-plus-lg.2fb3e8d306f57306f568b0264687fcfc.svg";
export { ForwardRef as ReactComponent };